<template>
  <InfringingWorkDetails
    v-if="flagged.step.value === 'details'"
    :variant="variant"
    :details="flagged.details.value"
    :local="flagged.local.value"
    @view-registration="flagged.openFile"
  />

  <div v-else-if="flagged.step.value === 'confirm'">
    <MatchCompareCard v-bind="flagged.works.value" />
    <ReportCost />
    <Alert
      v-if="flagged.error.value"
      variant="error"
      :icon="AlertIcon"
      class="mt-3.5"
    >
      {{ flagged.error.value }}
    </Alert>
    <Button
      variant="primary"
      size="lg"
      class="mt-[19px] h-10! w-full"
      :loading="flagged.creating.value"
      @click="flagged.confirm"
    >
      Create report
    </Button>
  </div>

  <div v-else>
    <MatchCompareCard
      v-bind="flagged.works.value"
      :actions="{
        onView: flagged.viewRegistered,
        onDetails: flagged.openDetails,
      }"
    />
    <MatchLevelPanel :panel="flagged.panel.value" />
    <Button
      variant="primary"
      size="lg"
      class="mt-[34px] h-10! w-full"
      :disabled="flagged.credits.value === undefined"
      @click="flagged.handleCreate"
    >
      Create report
    </Button>
  </div>
</template>

<script setup lang="ts">
import { Alert, Button } from '@dacr/library'
import { AlertIcon } from '@dacr/icons'

import InfringingWorkDetails from '../match/InfringingWorkDetails.vue'
import MatchCompareCard from '../match/MatchCompareCard.vue'
import MatchLevelPanel from '../match/MatchLevelPanel.vue'
import ReportCost from '../match/ReportCost.vue'
import type { FlaggedMatch } from './useFlaggedMatch'

defineProps<{ variant: 'modal' | 'sheet'; flagged: FlaggedMatch }>()
</script>
